import React, { useState, useEffect, useRef } from "react";
import { useSelector, shallowEqual } from "react-redux";
import Portal from "../portal";
import { FiX } from "react-icons/fi";
import { API_CreateAttribute, url } from "../../apis/constant";
import { toast } from "react-toastify";
import axios from "axios";
import InputTag from "../tags/InputTag";

const AddAttribute = ({ id, title, getApi }) => {
  const alphanumericRegex = /^[a-zA-Z0-9-. ]+$/;
  const adminToken = localStorage.getItem("wed_admin_token");
  const [error, setError] = useState("");
  const [attNameerror, setAttNameError] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [nameValue, setNameValue] = useState("");
  const [attNameValue, setAttNameValue] = useState("");
  const [tags, setTags] = React.useState([]);
  const [tagError, setTagError] = useState("");

  const { palettes } = useSelector(
    (state) => ({
      palettes: state.palettes,
    }),
    shallowEqual
  );
  let { background } = {
    ...palettes,
  };

  const modalRef = useRef(null);
  const [open, setOpen] = useState(false);
  const show = () => {
    getsubcategoryById();
    setOpen(true);
  };
  const hide = () => {
    setOpen(false);
    setNameValue("");
    setAttNameValue("");
    setTags([]);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!modalRef || !modalRef.current) return false;
      if (!open || modalRef.current.contains(event.target)) {
        return false;
      }
      setOpen(!open);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, modalRef]);

  const getsubcategoryById = () => {
    axios
      .get(url + API_CreateAttribute, +"/" + id, {
        headers: { Authorization: `Bearer ${adminToken}` },
      })
      .then((res) => {
        if (res.data.code === 200) {
          setNameValue(res.data.data.attributeDisplayName);
          setAttNameValue(res.data.data.attributeName);
        }
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  };
  const handleChange = (value, type) => {
    if (type === "name") {
      const limit = 200;
      if (value.length <= limit) {
        setAttNameError("");
        setNameValue(value);
      } else if (value && !alphanumericRegex.test(value)) {
        setAttNameError("Name should not be blank");
        setNameValue(value);
      } else {
        setAttNameError("Please enter less than 200 words");
      }
    } else if (type === "attname") {
      const limit = 200;
      if (value.length <= limit) {
        setError("");
        setAttNameValue(value);
      } else if (value && !alphanumericRegex.test(value)) {
        setError("Attribute Display Name should not be blank.");
        setAttNameValue(value);
      } else {
        setError("Please enter less than 200 words");
      }
    }
  };

  const submitAttribute = () => {
    let isTrue = false;
    setIsSubmit(true);
    if (nameValue === "") {
      setAttNameError("Attribute Name should not be blank.");
      setIsSubmit(false);
      isTrue = true;
    } else {
      setAttNameError("");
    }
    if (attNameValue === "") {
      setError("Attribute Display Name should not be blank.");
      setIsSubmit(false);
      isTrue = true;
    } else {
      setError("");
    }

    if (tags.length === 0) {
      setTagError("Variation should not be blank.");
      setIsSubmit(false);
      // return;
      isTrue = true;
    } else {
      setTagError("");
    }

    if (isTrue) {
      return;
    }

    let logData = {
      attributeName: nameValue,
      attributeDisplayName: attNameValue,
      variation: tags,
    };
    axios
      .post(url + API_CreateAttribute, logData, {
        headers: { Authorization: `Bearer ${adminToken}` },
      })
      .then((res) => {
        if (res.data.code === 200) {
          toast.success(res.data.message);
          hide();
          getApi(10, "", 1);
          setIsSubmit(false);
        } else if (res.data.code === 400) {
          toast.error(res.data.message);
          setIsSubmit(false);
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err.response.data.message);
      });
  };

  const onAddTag = (tag) => {
    setTags([...tags, ...tag]);
  };

  const onDeleteTag = (tag) => {
    let remainingTags = tags.filter((t) => {
      return t !== tag;
    });
    setTags([...remainingTags]);
  };

  return (
    <>
      <button
        className="btn btn-default btn-rounded bg-blue-500 hover:bg-blue-600 text-white add_att_btn"
        type="button"
        onClick={show}
      >
        Add Attribute
      </button>
      {open && (
        <Portal selector="#portal">
          <div className="modal-backdrop fade-in"></div>
          <div
            className={`modal show ${background === "dark" ? "dark-mode" : ""}`}
            data-background={background}
          >
            <div
              className="relative min-w-sm w-auto mx-auto lg:max-w-5xl"
              ref={modalRef}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h3 className="text-xl font-semibold">{title}</h3>
                  <button
                    className="modal-close btn btn-transparent"
                    onClick={hide}
                  >
                    <FiX size={18} className="stroke-current" />
                  </button>
                </div>

                <div className="relative p-4 flex-auto">
                  <label>Attribute Name</label>
                  <div className="inputBoxCategoryCss">
                    <input
                      type="text"
                      placeholder="Please Enter Title"
                      name="name"
                      value={nameValue}
                      onChange={(e) => handleChange(e.target.value, "name")}
                      className="inputFields"
                    />
                  </div>
                  {attNameerror && (
                    <p style={{ color: "red", paddingTop: "10px" }}>
                      {attNameerror}
                    </p>
                  )}
                </div>

                <div className="relative p-4 flex-auto">
                  <label>Attribute Display Name</label>
                  <div className="inputBoxCategoryCss">
                    <input
                      type="text"
                      placeholder="Please Enter Title"
                      name="attname"
                      value={attNameValue}
                      onChange={(e) => handleChange(e.target.value, "attname")}
                      className="inputFields"
                    />
                  </div>

                  {error && (
                    <p style={{ color: "red", paddingTop: "10px" }}>{error}</p>
                  )}
                </div>

                <div className="relative p-4 flex-auto">
                  <label>Variation</label>

                  <div className="form-element">
                    <div className="inputTag">
                      <InputTag
                        className="inputFields"
                        onAddTag={onAddTag}
                        onDeleteTag={onDeleteTag}
                        defaultTags={tags}
                        placeholder="enter tags separated by comma"
                      />
                    </div>
                    {tagError && <p style={{ color: "red" }}>{tagError}</p>}
                  </div>
                </div>

                <div className="modal-footer space-x-2">
                  <button
                    className="btn btn-default btn-rounded bg-blue-500 hover:bg-blue-600 text-white"
                    type="button"
                    onClick={hide}
                  >
                    Close
                  </button>
                  {isSubmit ? (
                    <button
                      className="btn btn-default btn-rounded bg-blue-500 hover:bg-blue-600 text-white"
                      type="button"
                    >
                      Loading...
                    </button>
                  ) : (
                    <button
                      className="btn btn-default btn-rounded bg-blue-500 hover:bg-blue-600 text-white"
                      type="button"
                      onClick={() => submitAttribute()}
                    >
                      Save Changes
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Portal>
      )}
    </>
  );
};

export default AddAttribute;
